import axios from "./axios";

class FormService {
  finoCspInquiry = async (formData) => {
    try {
      const response = await axios.post("/form/fino_csp_inquiry", formData);

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}
export default new FormService();
